export default function TypingText() {

    return (
        <div className="typing-container">Bot is typing...</div>
    );
};
